import React, { useRef, useState, useEffect } from "react";
import "../css/audiotrack.css";
import "../css/fonts.css";
import { useIsMobile } from "../hooks/is.mobile";

type AudioPlayerProps = {
  src: string;
};

export const AudioPlayer: React.FC<AudioPlayerProps> = ({ src }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [volume, setVolume] = useState(0.75); // volume from 0 to 1

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateProgress = () => {
      setProgress((audio.currentTime / audio.duration) * 100 || 0);
    };

    const handleEnded = () => setIsPlaying(false);

    audio.addEventListener("timeupdate", updateProgress);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateProgress);
      audio.removeEventListener("ended", handleEnded);
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
      audioRef.current.currentTime = 0;
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };
  const isMobile = useIsMobile();
  return (
    <div className="container">
      <audio ref={audioRef} src={src} />
      <button
        onClick={togglePlay}
        className="button"
        style={{
          backgroundColor: isPlaying
            ? "rgb(151, 109, 109)"
            : "rgb(126, 182, 140)",
        }}
      >
        <label className={"button-text" + " " + "title-text-font"}>
          {isPlaying ? "Stop" : "Play"}
        </label>
      </button>
      <div></div>
      <div></div>
      <div></div>
      <div className={"volume-text" + " " + "title-text-font"}>Volume</div>
      <input
        id="volume"
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={volume}
        onChange={handleVolumeChange}
        className="volume-bar"
        style={{
          background: `linear-gradient(to right,rgb(127, 118, 146) 0%,rgb(143, 172, 186) ${
            volume * 100
          }%, #444 ${volume * 100}%, #444 100%)`,
        }}
      />
    </div>
  );
};
